module.exports = __webpack_public_path__ + "static/media/cow-mooing.6f19ae65.png";